var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 106,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_2536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5171 64.0971L61.8088 64.0181V59.91C62.4628 60.2165 63.1918 60.3263 63.9071 60.2261C65.7368 59.9543 66.6279 58.33 66.7322 58.1278L66.8934 38.924C66.6692 37.4081 66.0256 35.9852 65.0353 34.8159C63.7844 33.3716 62.0752 32.4009 60.194 32.0666L47.3673 31.9086C45.4276 32.3997 43.6831 33.4687 42.3649 34.9739C41.3459 36.1567 40.6253 37.5665 40.2634 39.0852L40.1054 57.1576C40.1277 57.7117 40.3063 58.2481 40.6206 58.705C40.9349 59.1618 41.372 59.5204 41.8814 59.7394C42.3141 59.9039 42.7785 59.9678 43.2395 59.9262C43.7005 59.8846 44.146 59.7386 44.5422 59.4992C44.6243 67.2161 44.7055 74.9351 44.7855 82.6563C44.8589 83.5285 45.2382 84.3468 45.8563 84.9666C46.4744 85.5864 47.2916 85.968 48.1636 86.0439C48.8943 86.0681 49.6156 85.8735 50.235 85.485C50.8544 85.0965 51.3435 84.5318 51.6397 83.8634L51.4785 62.16C51.4785 61.4237 52.316 60.7253 53.2134 60.6274C54.1109 60.5294 54.9831 61.0572 55.3528 62.2422C55.5359 62.8424 55.5919 63.4741 55.5171 64.0971Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9469 43.4427C44.9469 49.1593 44.6309 54.8727 44.6309 60.5893",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8091 59.5781V43.4617",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5709 64.2331C55.5709 66.4641 55.5793 68.6962 55.5962 70.9293L61.8089 70.8756C61.7014 68.6951 61.91 66.5178 61.8089 64.3405C59.8307 64.3026 57.5428 64.2679 55.5709 64.2331Z",
    fill: "#BEBCFA",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3803 71.1979V86.1261H55.6784H61.4361",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9848 27.9519C58.0845 27.9519 61.4079 24.6285 61.4079 20.5289C61.4079 16.4293 58.0845 13.1059 53.9848 13.1059C49.8852 13.1059 46.5618 16.4293 46.5618 20.5289C46.5618 24.6285 49.8852 27.9519 53.9848 27.9519Z",
    fill: "white",
    stroke: "#4540DB",
    strokeWidth: 2.21205,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_2536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 75.2319,
    fill: "white",
    transform: "translate(39 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/Disabled.c7cd5a2d849ab734b2873ee2a0ecd07b.svg";
export { ForwardRef as ReactComponent };